import { render, staticRenderFns } from "./center_7.vue?vue&type=template&id=c87d7c10&scoped=true&"
import script from "./center_7.vue?vue&type=script&lang=js&"
export * from "./center_7.vue?vue&type=script&lang=js&"
import style0 from "./center_7.vue?vue&type=style&index=0&id=c87d7c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c87d7c10",
  null
  
)

export default component.exports